import { createSlice } from "@reduxjs/toolkit";
import { fetchDefaultPayoutAccountReducer } from "../../reducer/payoutAccount/fetchDefaultPayoutAccountReducer";
import { savePayoutAccountReducer } from "../../reducer/payoutAccount/savePayoutAccountReducer";
import { submitSettlementRequestReducer } from "../../reducer/settlement/submitSettlementRequestReducer";
import { fetchProviderSettlementsReducer } from "../../reducer/settlement/fetchProviderSettlementsReducer";
import { fetchProviderDashboardReducer } from "../../reducer/settlement/fetchProviderDashboardReducer";

import i18n from "../../i18n";
const initialState = {
  defaultAccount: null,
  settlements: [],
  dashboards: { normal: null, insured: null },
  isLoading: false,
  isSaving: false,
  isSubmitting: false,
  isLoadingSettlements: false,
  lastRequest: null,
  error: null,
};

const payoutAccountSlice = createSlice({
  name: "payoutAccount",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ---- fetch default payout account ----
      .addCase(fetchDefaultPayoutAccountReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDefaultPayoutAccountReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.defaultAccount = action.payload || null;
      })
      .addCase(fetchDefaultPayoutAccountReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.defaultAccount = null;
        state.error = action.payload || null;
      })
      // ---- save payout account ----
      .addCase(savePayoutAccountReducer.pending, (state) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(savePayoutAccountReducer.fulfilled, (state, action) => {
        state.isSaving = false;
        state.defaultAccount = action.payload || state.defaultAccount;
      })
      .addCase(savePayoutAccountReducer.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload || i18n.t("toast.failedToSavePayoutAccount");
      })
      // ---- submit settlement / withdrawal request ----
      .addCase(submitSettlementRequestReducer.pending, (state) => {
        state.isSubmitting = true;
        state.error = null;
      })
      .addCase(submitSettlementRequestReducer.fulfilled, (state, action) => {
        state.isSubmitting = false;
        state.lastRequest = action.payload || null;
      })
      .addCase(submitSettlementRequestReducer.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload || i18n.t("toast.failedToSubmitWithdrawalRequest");
      })
      // ---- fetch provider settlement history ----
      .addCase(fetchProviderSettlementsReducer.pending, (state) => {
        state.isLoadingSettlements = true;
      })
      .addCase(fetchProviderSettlementsReducer.fulfilled, (state, action) => {
        state.isLoadingSettlements = false;
        state.settlements = action.payload?.data || [];
      })
      .addCase(fetchProviderSettlementsReducer.rejected, (state, action) => {
        state.isLoadingSettlements = false;
        state.error = action.payload || state.error;
      })
      // ---- fetch per-order-type net balance for the withdrawal screen ----
      .addCase(fetchProviderDashboardReducer.fulfilled, (state, action) => {
        const orderType = action.payload?.order_type || "normal";
        state.dashboards[orderType] = action.payload?.summary || null;
      });
  },
});

export default payoutAccountSlice.reducer;
